import router from './router'
import useHelpRecipientStore from './store'
import HelpRecipientMessages from './localization'

export default {
  router,
  useHelpRecipientStore,
  localization: HelpRecipientMessages,
}
